import React, { useState } from 'react';
import './ExcludeNodeTree.css';
import FieldHelp from '../help/FieldHelp';

const ExcludeNodeTree = ({ treeNode, excludedIds, onToggleExclude }) => {
  const [expandedNodes, setExpandedNodes] = useState(new Set());

  const toggleExpand = (id) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const renderNode = (node, level = 0) => {
    if (!node) return null;
    
    // Check if node has children correctly (working with backend hierarchy shape)
    const children = Array.isArray(node.children) 
      ? node.children 
      : (node.children ? Object.values(node.children) : []);
      
    const hasChildren = children.length > 0;
    const isExpanded = expandedNodes.has(node.meter_id);
    const isExcluded = excludedIds.includes(node.meter_id);

    return (
      <div key={node.meter_id} style={{ marginLeft: level > 0 ? 20 : 0, marginTop: 6 }}>
        <div 
          className={`exclude-node-row ${isExcluded ? 'excluded' : ''}`}
          onClick={(e) => {
             // ensure we only toggle exclude when row is clicked, 
             // but if they click the expansion triangle, it handles its own click via stopPropagation
             onToggleExclude(node.meter_id);
          }}
        >
          {hasChildren ? (
            <span 
              onClick={(e) => { e.stopPropagation(); toggleExpand(node.meter_id); }} 
              style={{ cursor: 'pointer', display: 'inline-block', width: 16, textAlign: 'center', transition: 'transform 0.2s', transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', color: '#64748b' }}
            >
              ▶
            </span>
          ) : (
            <span style={{ width: 16 }} /> /* Space for alignment */
          )}
          
          <div className="status-checkbox">
             {!isExcluded ? <span className="status-icon">✓</span> : <span className="status-icon">✕</span>}
          </div>

          <span className="exclude-node-text" style={{ fontSize: 13, flex: 1 }}>
            {node.machine_name || node.name} 
            {node.category && node.category !== "VIRTUAL" && node.category !== "Unknown" && <span style={{ marginLeft: 8, fontSize: 10, background: isExcluded ? '#e2e8f0' : '#bbf7d0', padding: '2px 6px', borderRadius: 4, color: isExcluded ? '#94a3b8' : '#15803d', transition: 'all 0.2s' }}><FieldHelp id="customization.nodeCategory">{node.category}</FieldHelp></span>}
          </span>
        </div>
        
        {hasChildren && isExpanded && (
          <div style={{ paddingLeft: 4, borderLeft: '1px dashed #cbd5e1', marginLeft: 13, marginTop: 4 }}>
            {children.map(child => renderNode(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  const topLevelChildren = Array.isArray(treeNode.children) 
    ? treeNode.children 
    : (treeNode.children ? Object.values(treeNode.children) : []);

  if (topLevelChildren.length === 0) {
    return <div style={{ fontSize: 13, color: '#64748b', padding: 12, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>No sub-machines available to exclude under this selection.</div>;
  }

  return (
    <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: 16 }}>
      <h4 style={{ margin: '0 0 12px 0', fontSize: 14, color: '#0f172a', fontWeight: 600 }}><FieldHelp id="customization.includedMachines">Included machines</FieldHelp>:</h4>
      <p style={{ margin: '0 0 16px 0', fontSize: 13, color: '#64748b' }}>Click a machine to exclude it from this credential.</p>
      <div style={{ maxHeight: 300, overflowY: 'auto', paddingRight: 4 }}>
        {topLevelChildren.map(child => renderNode(child, 0))}
      </div>
    </div>
  );
};

export default ExcludeNodeTree;
